/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".flex--stretch[_ngcontent-%COMP%]{flex:1}.resend-invoices-dialog[_ngcontent-%COMP%]   .mat-dialog-title[_ngcontent-%COMP%]{min-height:120px}.resend-invoices-dialog[_ngcontent-%COMP%]   .mat-dialog-title[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:30px;height:30px;margin-right:8px;width:30px}.resend-invoices-dialog-actionbar.mat-dialog-actions[_ngcontent-%COMP%]{justify-content:space-between!important}"];
export { styles as styles };

